import { createClient } from '@supabase/supabase-js';

// Initialize the Supabase client with the environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables. Please check your .env file.');
}

// Create Supabase client instance
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Create SQL statement for waitlist table if it doesn't exist
export const createWaitlistTableSQL = `
CREATE TABLE IF NOT EXISTS waitlist (
  id SERIAL PRIMARY KEY,
  email TEXT UNIQUE NOT NULL,
  country TEXT NOT NULL, -- Stores ISO 3166-1 alpha-2 country code (e.g., 'US', 'GB', 'JP')
  created_at TIMESTAMP WITH TIME ZONE DEFAULT NOW()
);
`; 